import {
	AfterContentChecked,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output
} from '@angular/core';
import {FormControl} from '@angular/forms';

@Component({
	selector: 'app-dropdown',
	templateUrl: './dropdown.component.html',
	styleUrls: ['./dropdown.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush

})
export class DropdownComponent implements OnInit, AfterContentChecked {

	@Input() array: any[];
	@Input() default: string;
	@Input() label: string;
	@Input() placeholder: string;
	@Input() valueInput: any;
	@Output() value = new EventEmitter<string>();
	control = new FormControl(' ');

	constructor(private cdr: ChangeDetectorRef) {
	}

	ngOnInit() {
		// this.control.setValue(this.valueInput);
		this.onFrom(this.valueInput);
	}

	onFrom(value: any) {
		this.value.emit(value);
	}

	ngAfterContentChecked(): void {
		this.cdr.detectChanges();
	}
}
